import { gql } from 'apollo-angular';
import { ADDRESS_FIELDS_FRAGMENT } from "./address-fragment-definition";
import { DISCOUNT_GROUP_RELATION_DOCUMENT_BASE_FRAGMENT } from "./discount-group.definition";
import { DELETION_RESPONSE_FRAGMENT } from './system-definition';

export const DISCOUNT_GROUP_VENDOR_RELATION_FRAGMENT = gql`
fragment DiscountGroupVendorRelation on DiscountGroupVendorRelation {
    ...DiscountGroupRelationDocumentBase
    vendorId
    vendor {
        ...AddressFields
    }
}
${DISCOUNT_GROUP_RELATION_DOCUMENT_BASE_FRAGMENT}
${ADDRESS_FIELDS_FRAGMENT}
`;

export const GET_DISCOUNT_GROUP_VENDOR_RELATIONS = gql`
query GetDiscountGroupVendorRelations($input:DiscountGroupVendorRelationSearchInput) {
    getDiscountGroupVendorRelations(input: $input) {
        totalItems
        items {
            ...DiscountGroupVendorRelation
        }
    }
}
${DISCOUNT_GROUP_VENDOR_RELATION_FRAGMENT}
`;

export const GET_DISCOUNT_GROUP_VENDOR_RELATION = gql`
query GetDiscountGroupVendorRelation($id:String!) {
    getDiscountGroupVendorRelation(id: $id) {
        ...DiscountGroupVendorRelation
    }
}
${DISCOUNT_GROUP_VENDOR_RELATION_FRAGMENT}
`;


export const SAVE_DISCOUNT_GROUP_VENDOR_RELATION = gql`
mutation SaveDiscountGroupVendorRelation($input: DiscountGroupVendorRelationInput!) {
    saveDiscountGroupVendorRelation(input: $input) {
        ... DiscountGroupVendorRelation
    }
}
${DISCOUNT_GROUP_VENDOR_RELATION_FRAGMENT}
`;

export const DELETE_DISCOUNT_GROUP_VENDOR_RELATION = gql`
mutation DeleteDiscountGroupVendorRelation($id: String!) {
    deleteDiscountGroupVendorRelation(id: $id) {
        ... DeletionResponse
    }
}
${DELETION_RESPONSE_FRAGMENT}
`;